import { result } from 'lodash-es';

import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import { ICodeInfo } from './types/affiliate';
import { IBaseResponse } from './types/common';

export function getUserCodeInfo(params: { source: 0 | 1 | 2 }) {
  return new Promise((resolve, reject) => {
    const url = `${API2_HOST}/affiliate/apis/v1/bind_aff_user_info`;
    fetchData
      .post<IBaseResponse<ICodeInfo>>(url, { body: JSON.stringify(params) })
      .then((response) => {
        resolve(response);
        // resolve({
        //   result: {
        //     affId: '123',
        //     isAnonymous: false,
        //     isBeInvited: false,
        //     isPro: false,
        //     isQualify: false,
        //     nickName: 'jackyasdasdgsadhjfgs safds  fdsaf sdf dfas dfsdf asd',
        //     userId: 0,
        //     groupId: 123,
        //     euRewardShow: 1,
        //   },
        // });
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}
